import React, { useState, useRef, useLayoutEffect } from "react";
import { Typography, Tooltip, TypographyProps, TooltipProps } from "@mui/material";

interface TruncatedTitleProps {
  text: string;
  maxLines?: number;
  variant?: TypographyProps["variant"];
  sx?: TypographyProps["sx"];
  tooltipPlacement?: TooltipProps["placement"];
}

const TruncatedTitle: React.FC<TruncatedTitleProps> = ({
  text,
  maxLines = 2,
  variant = "h6",
  sx = {},
  tooltipPlacement = "top",
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsTruncated(element.scrollHeight > element.clientHeight);
    }
  }, [text]);

  return (
    <Tooltip 
      title={text} 
      arrow 
      placement={tooltipPlacement} 
      disableHoverListener={!isTruncated}
    >
      <Typography
        ref={textRef}
        variant={variant}
        sx={{
          ...sx,
          display: "-webkit-box",
          WebkitLineClamp: maxLines,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text}
      </Typography>
    </Tooltip>
  );
};

export default TruncatedTitle;
